import { io } from "socket.io-client";
let baseUrl;
if (process.env.NODE_ENV === 'production')
{
	baseUrl = 'https://quickroom-server.onrender.com' 
	// https://quickroom-server.herokuapp.com/
} else
{
	baseUrl = 'http://localhost:7500/'
}
const socket = io(baseUrl);

export { baseUrl, socket }
